import i18n from 'i18n'

const ShowSuccessMsg = ({firstName, gender}) => {
  const isFrench = i18n.language.startsWith('fr')

  return (
    <div
      className='d-flex align-items-center justify-content-center px-3 py-10'
      style={{minHeight: '70vh'}}
    >
      <div className='card border-0 shadow-sm w-100' aria-live='polite'>
        <div className='card-body text-center p-6 p-md-10'>
          <div
            className='d-inline-flex align-items-center justify-content-center rounded-circle bg-light-success mb-6'
            style={{width: '90px', height: '90px'}}
          >
            <i className='fas fa-check-circle text-success' style={{fontSize: '52px'}} />
          </div>

          <p className='fs-5 text-gray-700 lh-lg mb-0'>
            {isFrench ? (
              <>
                {(gender == 1 ? 'Cher ' : 'Chère ') + firstName},
                <br />
                <br />
                Nous vous remercions pour votre demande d’inscription. Votre demande a bien été
                transmise.
                <br />
                <br />
                Un e-mail de confirmation vous sera envoyé dans un délai maximal de 48 heures.
                <br />
                <br />
                Notre Service des admissions vous contactera prochainement si des informations ou
                des documents complémentaires sont nécessaires.
                <br />
                <br />
                Cordialement,
                <br />
                <span className='text-primary'>Le Service des admissions</span>
              </>
            ) : (
              <>
                Dear {firstName},
                <br />
                <br />
                Thank you for submitting your application. Your application has been received
                successfully.
                <br />
                <br />
                A confirmation email will be sent to you within a maximum of 48 hours.
                <br />
                <br />
                Our Admissions Office will contact you if any additional information or supporting
                documents are required.
                <br />
                <br />
                Kind regards,
                <br />
                <span className='text-primary'>Admissions Office</span>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default ShowSuccessMsg
